 import { useDisclosure } from "@chakra-ui/hooks";
 import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/modal";
 import { refundPayment } from "api/payments";
 import Card from "components/card";
 import DivLoader from "components/divloader/DivLoader";
 import React, { useState } from "react";
 import { toast } from "react-hot-toast";
 import { MdOutlineReplayCircleFilled, MdPeople } from "react-icons/md";
 import { convertToFloat } from "utils/formatNumber";
 import { Popover, PopoverTrigger, PopoverContent, PopoverHeader , PopoverArrow } from "@chakra-ui/react";
 import { Portal } from '@chakra-ui/portal'
import ShortTruncateCopy from "components/common/RegistrationLinkCopy";
 
 const CustomerRegistration = ({
   client_id
 }: {
   client_id?: any;
 }) => {
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [isLoading, setIsLoading] = React.useState<boolean>();
    const ClientLink = "https://"+window.location.hostname+ "/customer/register/"+client_id;
    const [generatedLink,setGeneratedLink] = useState(ClientLink)
   const handleClose = () => {
     onClose();
   };
   return (
     <>
       <Popover trigger="hover" placement="bottom">
         <PopoverTrigger>
           <span className="inline-flex">
             <button
               className="outline-none disabled:cursor-not-allowed disabled:opacity-50"
               onClick={onOpen}
             >
               <MdPeople
                //  className={
                //    varient === "small"
                //      ? "h-[21px] w-[21px] text-blue-500"
                //      : ""
                //  }
                 className = "h-6 w-6 text-blue-500"
               />
             </button>
           </span>
         </PopoverTrigger>  
         <Portal > 
           <PopoverContent borderColor='blue.800' className="z-20 dark:bg-gray-800 shadow  invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800 p-3 border-6 shadow !bg-gray-700">
             <PopoverHeader>
               <span className="text-sm  font-bold text-white">
                Customer Registration Generic Link
             </span>
             </PopoverHeader>
             <PopoverArrow  className="border h-8 w-8 border-gray-700 !bg-gray-700  "  />
           </PopoverContent>
         </Portal>
       </Popover>
       
       <Modal isOpen={isOpen} onClose={onClose}>
         <ModalOverlay className="bg-[#000] !opacity-30" />
         <ModalContent className="sm:max-w-xxl z-[1002] !m-auto flex min-h-[100vh] max-w-[800px] justify-center !p-3 sm:my-8 sm:w-full">
           <ModalBody>
             <Card extra=" max-w-[800px]   flex flex-col !z-[1004]">
               <h1 className="p-3 px-[30px] text-2xl font-bold">
                 Registration Link
               </h1>
               <div className="mx-[35px]">
                 <p>
                   Here is the generic link of the customer registration , copy below mentioned url it will get you to customer registration page.
                 </p>
                 <p className="mt-3">
                   <ShortTruncateCopy info={generatedLink} showCopy={true} />
                 </p>
               </div>
 
               <div className="mt-5 flex gap-2 px-[30px] pb-[30px]">
                 <button
                   onClick={handleClose}
                   className="linear rounded-xl bg-indigo-600 px-5 py-2 text-white font-medium text-navy-700 outline-none transition duration-200 hover:bg-indigo-500 active:bg-indigo-500 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                >
                   Close
                 </button>
               </div>
             </Card>
           </ModalBody>
         </ModalContent>
       </Modal>
     </>
   );
 };
 export default CustomerRegistration;
 